export enum SettingsPageTabs {
  Account = 'Account',
  Members = 'Team members',
  Billing = 'Billing',
  LoginOptions = 'Login options',
}
